import { useBrand } from '@contexts/index'
import { type ReactElement } from 'react'
import { twMerge } from 'tailwind-merge'

import Logo from '../logo'
import Stepper from './stepper'
import Title from './title'

type Props = {
  logo?: ReactElement
  title: string
  steps?: ReactElement[]
  background?: {
    src: string
  }
  color?: string
  logoType?: string
  customLogo?: string
}

const getLogoWidth = (brand: string, logoType?: string) => {
  const type = logoType || brand
  switch (type) {
    case 'kinto':
      return 'w-[80px] mt-[2px]'
    case 'lexus-kinto':
      return 'w-[160px] mt-[2px]'
    case 'toyota-kinto':
      return 'w-[160px] mt-[2px]'
    case 'toyota-lexus':
      return 'w-[160px] mt-[2px]'
    case 'lexus':
    case 'toyota':
    default:
      return 'w-[50px] lg:w-[65px]'
  }
}

// TODO: Fix to work with kinto and background types??
const Nav = ({
  title,
  steps,
  background,
  color,
  logoType,
  customLogo,
}: Props) => {
  const brand = useBrand()
  // TODO: Figure out what this is doing
  const imageUrl = `https://scene7.toyota.eu/is/image/toyotaeurope/${background}?qlt=80&wid=1920&hei=1080&fit=crop,1`

  const logoWidth = getLogoWidth(brand, logoType)

  const StepsNav = steps ? (
    <nav
      className={twMerge(
        `bg-primary sticky top-0 z-10 py-3 md:py-4 lg:py-6 text-base-text`,
        brand === 'lexus' && ' uppercase',
      )}
    >
      <div className="container h-[50px]">
        <Stepper steps={steps} />
      </div>
    </nav>
  ) : null

  return (
    <>
      {background ? (
        <>
          <header
            className={twMerge(
              `pt-6 pb-8 md:py-8 lg:pt-10 lg:pb-12 h-[300px] md:h-[350px] lg:h-[500px]`,
              steps ? '!pb-0' : '',
              brand === 'lexus' && ' uppercase',
              color === 'white' && 'text-white',
            )}
            style={{
              background: `no-repeat 50% 50% / cover url(${
                background.src ? background.src : imageUrl
              })`,
            }}
          >
            <div className="container flex items-center text-base-text">
              {customLogo ? (
                <img alt={brand} src={customLogo} />
              ) : (
                <Logo
                  width="65"
                  className={twMerge(
                    `logo ${logoWidth} shrink-0`,
                    color === 'white' && 'text-white',
                  )}
                  logoType={logoType}
                />
              )}
              <Title color={color}>{title}</Title>
            </div>
          </header>
          {StepsNav}
        </>
      ) : (
        <header
          className={twMerge(
            `bg-primary pt-6 pb-8 md:py-8 lg:pt-10 lg:pb-12 shadow-header`,
            steps && '!pb-0',
            brand === 'lexus' && ' uppercase',
          )}
        >
          <div className="container flex items-center text-base-text">
            {customLogo ? (
              <img alt={brand} src={customLogo} />
            ) : (
              <Logo
                width="65"
                className={`logo ${logoWidth} shrink-0`}
                logoType={logoType}
              />
            )}
            <Title>{title}</Title>
          </div>
          {StepsNav}
        </header>
      )}
    </>
  )
}

export default Nav
